export interface IProjectInfo {
  name: string;
  credits_tab: boolean;
  leasings_tab: boolean;
  own_capitals_tab: boolean;
  working_capital_tab: boolean;
  venture_tab: boolean;
  capexs_tab: boolean;
  currency: string;
  currency_multiplication: string;
  project_mode: string;
  is_public?: boolean;
  current_user_subscribed_to_project: boolean;
}
